<template>
<v-container fluid class="pa-0">
    <v-toolbar class="elevation-0" flat color="barrinfo">
        <v-toolbar-title :class="contextStyle.titleClass">
            <v-icon large :color="contextStyle.titleColor" :class="contextStyle.titleIcon">{{ contextStyle.icon }}</v-icon>
            <span>{{ contextStyle.title }}</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="success" depressed class="white--text" :to="'/' + $route.name + '/0'">
            <v-icon left dark>mdi-plus-circle</v-icon>
            <span class="hidden-sm-and-down">Créer</span>
        </v-btn>
    </v-toolbar>

    <v-card class="ma-4 rounded-lg">
    <v-data-table v-bind:headers="headers" :items="items" item-key="sta_id" :search="search"
        items-per-page-text="Lignes par page" :items-per-page-options="pagination.rowsPerItem">
        <template v-slot:top>
            <v-row class="rounded-lg ma-0 pa-0" style="background-color: #FAFAFA">
                <v-col cols="6" md="6" class="pa-1">
                <v-text-field append-icon="mdi-magnify" label="Recherche" outlined dense clearable single-line
                            hide-details v-model="search" @blur="saveSearchToCache()" class="pa-2 rounded-xl">
                </v-text-field>
                </v-col>
                <v-col cols="6" md="6" class="text-right pa-1"></v-col>
            </v-row>
        </template>
        crosshairs-gps
        <template v-slot:[`item.equ_code`]="{ item }">
            <span>{{ item.equ_code }}</span>
            <v-icon small v-if="item.equ_customfields['equ_tomtom']" class="ml-1"
                :title="'Boitier: ' + item.equ_customfields['equ_tomtom'] + '\nIndex: ' + item.equ_usage_distance">
                mdi-crosshairs-gps
            </v-icon>
        </template>
        <template v-slot:[`item.equ_sta_id`]="{ item }">
            <v-chip small outlined label>{{ equStatus[item.equ_sta_id] }}</v-chip>
        </template>
        <template v-slot:[`item.cat_name`]="{ item }">
            <v-chip small outlined label>{{ item.cat_name }}</v-chip>
        </template>
        <template v-slot:[`item.equ_typ_id`]="{ item }">
            <v-btn outlined small color="grey" class="ml-2 elevation-1" :href="'/#/equipments/' + item.equ_id + ''">
                <v-icon left class="mr-2">mdi-pencil</v-icon>Modifier
            </v-btn>
        </template>
        <template v-slot:[`item.ent_name`]="{ item }">
            <v-chip small outlined label>{{ item.ent_name }}</v-chip>
        </template>
        <template v-slot:[`item.equ_typ_id_trade`]="{ item }">
            <v-chip small outlined label :color="getCacheType('TRA', item.equ_typ_id_trade).typ_color">
                {{ getCacheType('TRA', item.equ_typ_id_trade).typ_name }}
            </v-chip>
        </template>
        <template slot="pageText" slot-scope="{ pageStart, pageStop }">
        De {{ pageStart }} à {{ pageStop }}
        </template>
    </v-data-table>
    </v-card>
</v-container>
</template>

<script>
import dateLocale from '../services/dateLocale';
import { cacheGetters, cacheMutations } from "../store/cache.module"

export default {
    name: 'equipments',
    props: ['toast', 'contextStyle'],
    data: function () {
        return {
            saveProgress: false,         // Enregistrement en cours...
            search: '',
            pagination: { totalItems: 0, rowsPerPage: 10, rowsPerItem: [15,25,35,{text:'Tout',value:-1}] },
            headers: [
            { text: 'Id',            align: 'left', value: 'equ_code'},
            { text: 'Série',         align: 'left', value: 'equ_serial'},
            { text: 'Catégorie',     align: 'left', value: 'cat_name'},
            { text: 'Groupe',        align: 'left', value: 'grp_name'},
            { text: 'Modele',        align: 'left', value: 'bmo_code'},
            { text: 'Type',          align: 'left', value: 'equ_sta_id'},
            { text: 'Propriétaire',  align: 'left', value: 'ent_name'},
            { text: 'Aquisition',    align: 'left', value: 'equ_typ_id_trade'},
            { text: 'Modification',  align: 'right',value: 'equ_typ_id' }
            ],
            items: [],
            locDateFormat: dateLocale,
            enableAdd: true,
            modalEvent : false,
            cacheTab: this.$storage.localStorage.get( this.$APP_COD + "_cache" ),
            equStatus: {
                'GEN01' : 'Actif',
                'GEN02' : 'Inactif',
                'GEN03' : 'Terminé',
                'GEN04' : 'Archivé',
                'GEN05' : 'Supprimé',
            },
        }
    },
    computed: {
        pages () {
            if (this.pagination.rowsPerPage == null || this.pagination.totalItems == null ) return 0
            return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
        }
    },
    mounted: function (){
        this.search = cacheGetters.getSearchBarItem('equipments') || ''
        this.getItems()
    },
    methods: {
        getItems(){
            this.$http.get( '/equipments?per_page=false&extended=withentity,withcategory,withbrandmodel,withgroup' ).then( (response) => {
                this.items = response.data.data
            })
        },
        handlePage(index){
            this.pagination.limit = this.pagination.rowsPerPage * (index - 1)
        },
        getTypeName( typ_id ){
            if( this.cacheTab.types['SPE'] !== undefined && this.cacheTab.types['SPE'][typ_id] !== undefined ){
                return this.cacheTab.types['SPE'][typ_id].typ_name 
            } else {
                return 'non définit'
            }
        },
        saveSearchToCache(){
            cacheMutations.setSearchBarItem('equipments', this.search)
        },
        getCacheType: cacheGetters.getTypes,
    },
    components: {
        
    }
}
</script>